import { FC } from 'react';

import { i18n as I18n } from 'utils/i18n';

interface Space {
  name: string;
}

interface Props {
  space: Space;
  onChange?: () => void;
  onRemove?: () => void;
  changeLabel?: string;
  removeLabel?: string;
}

const SpaceDetails: FC<Props> = ({
  space: { name } = {},
  onChange: change,
  onRemove: remove,
  changeLabel = I18n.t('advanced_booking.space.change_room'),
  removeLabel = I18n.t('advanced_booking.space.remove'),
}) => {
  const links = [
    ...(change
      ? [
          <a key="change" onClick={change}>
            {changeLabel}
          </a>,
        ]
      : []),
    ...(remove
      ? [
          <a key="remove" onClick={remove}>
            {removeLabel}
          </a>,
        ]
      : []),
  ].reduce(
    (prev, curr) => (prev.length === 0 ? [curr] : [...prev, ' | ', curr]),
    []
  );

  return (
    <div className="calendar__space_details">
      <h4>{name}</h4>
      <div>{links}</div>
    </div>
  );
};

export default SpaceDetails;
